/* ============
 * ModuleTransformer
 * ============
 *
 * The transformer for the module.
 */

import Transformer from '@transformers/Transformer'

export default class ModuleTransformer extends Transformer {
  /**
   * Method used to transform a fetched Content.
   *
   * @param data The fetched Content.
   *
   * @returns {Object} The transformed Content.
   */
  static fetch (data) {
    let result = {
      key: data.key,
      name: data.name,
      description: false
    }

    if (data.hasOwnProperty('description')) {
      result.description = data.description
    }

    return result
  }
}
